<template>
  <div class="result-step-component">
    <div class="result-step-container d-flex flex-column justify-space-between">
      <div class="d-flex justify-space-between">
        <v-btn @click="stepBack" class="button" width="400px" outlined dark>
          <font-awesome-icon icon="chevron-left" class="mr-3" />
          Назад
        </v-btn>
        <div class="step">
          <span class="count">1.</span>
          <span class="d-block">Проговорить с клиентом  полностью его заказ и тем самым подтвердить его правильность.</span>
        </div>
      </div>
      <div class="d-flex justify-end">
        <div class="step">
          <span class="count">2.</span>
          <span class="d-block">После проверки заказа сориентируйте клиента по времени и подтвердите его!</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResultWindow',
    methods: {
      stepBack () {
        this.$store.commit('newOrder/toggleResultWindow', false)
      },
    },
  }
</script>

<style lang="less" scoped>
.result-step-component {
  position: fixed;
  left: 0;
  top: 0;
  width: calc(100% - 370px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  .media-xl({
    width: calc(100% - 454px);
  });

  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .result-step-container {
    position: fixed;
    top: 187px;
    left: 326px;
    height: calc(100% - 187px);
    width: calc(100% - 444px - 326px);
    padding-bottom: 34px;
  }

  .button {
    height: 80px;
    font-size: 1.07em;
    border-radius: 10px;

    svg {
      margin-right: 8px;
    }

    .media-xl-max({
      width: 200px !important;
    });
  }

  .step {
    color: #ffffff;
    font-size: 1.14em;
    max-width: 383px;
    padding-right: 17px;
    .count {
      display: flex;
      align-items: center;
      &:after {
        flex: 1;
        content: '';
        border: 1px dashed #ffffff;
        height: 1px;
      }
    }
  }

  // Компактный десктоп. Блок с подсказками был прибит к левому краю 326px -
  // ширине сайдбара на больших экранах; при полоске 80px ему оставалось 330px,
  // и первая подсказка сжималась в столбик рядом с кнопкой.
  .media-compact-pc({
    // полоска сайдбара поднята над страницей (z-index 7): затемнение должно
    // накрывать и её, как накрывает сайдбар на широком экране
    z-index: 8;

    .result-step-container {
      // подсказка 1 - на уровне первых позиций заказа, подсказка 2 - кнопки «Оформить»
      top: 72px;
      left: 96px;
      width: calc(100% - 370px - 96px);
      height: calc(100% - 72px);
      padding-bottom: 12px;
    }

    .button {
      height: 65px;
    }

    .step {
      font-size: 15px;
      line-height: 1.35;
    }
  });
}
</style>
